export default __webpack_public_path__ + "d45396d5a79d36b79d43b47cd9a50c8a.png";